import React, { useEffect, useState } from 'react';
import {
  Card,
  Typography,
  Grid,
  Box,
  CardContent,
  Alert,
  Container,
  AlertTitle,
  Button,
} from '@mui/material';
import { Pagination, PaginationItem } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { motion } from 'framer-motion';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Footer from '../components/footer/Footer';
import Header2 from '../components/Header2/Header2';
import Scrollbar from '../components/scrollbar/scrollbar';
import { Link, useParams } from 'react-router-dom';
import { LocationOn, Scale, Straighten } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './Loader/loader';
import {
  addDumpster,
  fetchDumpsters,
} from '../features/dumpsters/dumpsterSlice';
import DumpsterImage from '../images/dumpster.png';
import CardForm from './CardForm';

const DumpsterList = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const { slug } = useParams();
  useEffect(() => {
    dispatch(fetchDumpsters({ slug, page }));
  }, [dispatch, slug, page]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const {
    dumpsters,
    loading: dumpsterLoading,
    error,
    pagination,
  } = useSelector((state) => state?.dumpsters || {});
  console.log('dumpstersdumpsters', dumpsters);

  if (dumpsterLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{
            backgroundColor: '#d32f2f',
            color: 'white',
            padding: '16px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
            animation: 'fadeIn 0.5s ease-in-out',
          }}
        >
          <Box>
            <AlertTitle>Error</AlertTitle>
            <Typography sx={{ fontFamily: 'var(--font-body)' }} variant="body2">
              {error?.message ||
                'Something went wrong. Please try again later.'}
            </Typography>
          </Box>
        </Alert>
      </Box>
    );
  }
  const companyName = dumpsters?.company?.name || 'Unknown Company';

  const dumpsterList = dumpsters?.dumpster_sizes?.data || [];
  console.log('dumpsterList', dumpsterList);

  return (
    <>
      <main>
        <Header2 companyName={companyName} />
        <Container sx={{ py: 4, mt: 5 }}>
          <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
            {/* Title */}
            {/* <Typography
              sx={{
                color: '#14331D',
                fontFamily: 'var(--font-body)',
                fontWeight: '500',
              }}
              variant="h5"
              textAlign="center"
              mb={4}
            >
              🚛 {companyName} Dumpsters
            </Typography> */}

            {/* Cards */}
            <Grid container spacing={3} justifyContent="center">
              {dumpsterList.map((dumpster) => (
                <Grid item xs={12} sm={6} md={4} key={dumpster.id}>
                  <DumpsterCard
                    dumpster={dumpster}
                    handleAddDumpster={() => dispatch(addDumpster(dumpster))}
                    slug={slug}
                  />
                </Grid>
              ))}
            </Grid>

            {/* Pagination */}
            <Box
              sx={{
                position: 'sticky',
                bottom: 20,
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                mt: 4,
              }}
            >
              <Pagination
                count={pagination?.totalPages || 1}
                page={page}
                onChange={handleChangePage}
                showFirstButton={false}
                showLastButton={false}
                renderItem={(item) =>
                  item.type === 'previous' || item.type === 'next' ? (
                    <PaginationItem
                      {...item}
                      slots={{
                        previous: () => (
                          <ArrowBackIcon
                            sx={{ fontSize: '28px', fontWeight: 'bold' }}
                          />
                        ),
                        next: () => (
                          <ArrowForwardIcon
                            sx={{ fontSize: '28px', fontWeight: 'bold' }}
                          />
                        ),
                      }}
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        width: 55,
                        height: 55,
                        mx: 1,
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        '&:hover': {
                          backgroundColor: '#f0f0f0',
                        },
                      }}
                    />
                  ) : null
                }
              />
            </Box>
          </Box>
        </Container>
      </main>
      <Scrollbar />
      <Footer />
    </>
  );
};
const DumpsterCard = ({ dumpster, handleAddDumpster, slug }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <Card
        sx={{
          borderRadius: '16px',
          padding: '16px',
          maxWidth: 401,
          // height: '100%',
          height: '430px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', padding: '8px 12px' }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              mr: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              borderRadius: '50%',
              border: '1px solid #ddd',
            }}
          >
            <img
              src={dumpster?.image || DumpsterImage}
              alt={dumpster?.name || 'Dumpster'}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
            />
          </Box>

          <Box>
            <Typography
              variant="h6"
              sx={{
                fontFamily: 'var(--font-body)',
                color: '#333',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {dumpster.name}
            </Typography>
            <Box
              sx={{
                backgroundColor: '#75AD3E',
                color: 'white',
                padding: '2px 10px',
                borderRadius: '5px',
                fontSize: '20px',
                display: 'inline-block',
                marginTop: '5px',
              }}
            >
              {dumpster?.promotion?.discount ? (
                <>
                  {/* Original Rent */}
                  <span
                    style={{
                      textDecoration: 'line-through',
                      opacity: 0.8,
                      marginRight: '8px',
                    }}
                  >
                    ${dumpster?.rent || 'N/A'}
                  </span>

                  {/* Discounted Rent */}
                  <strong>
                    {`$${(
                      dumpster.rent -
                      (dumpster.rent * dumpster.promotion.discount) / 100
                    ).toFixed(2)}`}
                  </strong>
                </>
              ) : (
                <strong>${dumpster?.rent || 'N/A'}</strong>
              )}
            </Box>
          </Box>
        </Box>

        <CardContent sx={{ padding: '0 15px', flexGrow: 1, mt: 5 }}>
          {[
            {
              icon: <Straighten sx={{ color: '#555' }} />,
              label: 'Dimensions',
              value: dumpster?.name || 'N/A',
            },
            {
              icon: <CalendarMonthIcon sx={{ color: '#555' }} />,
              label: 'Rental time',
              value: dumpster ? `${dumpster?.minimum_days} days` : 'N/A',
            },
            {
              icon: <Scale sx={{ color: '#555' }} />,
              label: 'Included tonnage',
              value: dumpster?.weight ? `${dumpster?.weight} lbs` : 'N/A',
            },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                py: 1,

                borderBottom: '1px solid #ddd',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    py: 1,
                    gap: 0,
                  }}
                >
                  {item?.icon}
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: 'nowrap',
                    fontFamily: 'var(--font-body)',
                    fontWeight: 500,
                    color: '#444',
                  }}
                >
                  {item?.label}
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  color: '#555',
                  textAlign: 'right',
                  fontFamily: 'var(--font-body)',
                  whiteSpace: item.wrap ? 'normal' : 'nowrap',
                  overflowWrap: 'break-word',
                  fontSize: item.label === 'Location' ? '12px' : '14px',
                }}
              >
                {item?.value}
              </Typography>
            </Box>
          ))}
        </CardContent>

        <Box sx={{ mb: 1 }}>
          <Link
            onClick={() => dumpster && handleAddDumpster(dumpster)}
            to={`/dumpster/${slug}/${dumpster?.id}`}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#14331D',
                color: 'white',
                width: '100%',
                borderRadius: '8px',
                padding: '10px',
                fontSize: '15px',
                textTransform: 'none',
                '&:hover': { backgroundColor: '#2E7D32' },
              }}
              onClick={handleAddDumpster}
            >
              Book Dumpster Size
            </Button>
          </Link>
        </Box>
      </Card>
    </motion.div>
  );
};

export default DumpsterList;
